let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("hHrTM"), load("4rKYa"), load("ffEVr"), load("2NgQt")]).then(() => parcelRequire('cPinp'));